const getters = {
  CONTENT_TYPE: state => state.app.CONTENT_TYPE,
  PAGE: state => state.app.PAGE,
  nodeCode: state => state.app.nodeCode,
  wxAppId: state => state.app.wxAppId,
  shareRootUrl: state => state.app.shareRootUrl,
  appName: state => state.app.appName,
  appFullName: state => state.app.appFullName,
  userInfo: state => state.app.userInfo,
}
export default getters 